import React from 'react';

const HamburgerMenu = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 24 18" fill="none" {...props}>
      <path d="M1 9H23" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1 1H23" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1 17H23" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default HamburgerMenu;
